import {
  ChatBubbleBottomCenterIcon,
  EyeIcon,
  TagIcon,
} from '@heroicons/react/20/solid'

const features = [
  {
    name: 'Our Vision',
    description: `IPDCL envisions being a progressive property developer that 
		prides itself on its proven track records, passion and commitment to 
		deliver superior value in design, quality and delivery to our clients`,
    icon: EyeIcon,
    href: '/about',
  },
  {
    name: 'Our Mission',
    description: `We serve our customer diligently in meeting their requirement and 
		delivering value for their investment. We continuously learn and observe new 
		trends and customer requirements.`,
    icon: TagIcon,
    href: '/about',
  },
  {
    name: 'Our Philosophy',
    description: `We deliver beyond residential properties. We deliver to our customers the joy 
		of living, the serenity of space and the place to interact with their family. 
		A place for their children to grow. A place for them to rest and relax. A dream 
		home with a beautiful environment.`,
    icon: ChatBubbleBottomCenterIcon,
    href: '/about',
  },
]

export default function CompanyOverview() {
  return (
    <div className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base font-semibold leading-7 text-primary">
            About Interactive Property Development Company Limited (IPDCL)
          </h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-3xl">
            Everything you need in real estate development
          </p>
          <p className="mt-3 text-base leading-6 text-gray-600">
            Interactive Property Development Company Limited is consistent in
            executing and delivering quality projects covering most areas of the
            Federal Capital Territory. This presence provides our clients with
            complete designs, engineering and material supply resources that are
            vertically integrated with Engineering solutions.
          </p>
        </div>
        <div className="mx-auto mt-8 max-w-2xl sm:mt-16 lg:mt-20 lg:max-w-none">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
            {features.map((feature) => (
              <div key={feature.name} className="flex flex-col">
                <dt className="flex items-center gap-x-3 text-base font-semibold leading-7 text-gray-900">
                  <feature.icon
                    aria-hidden="true"
                    className="h-5 w-5 flex-none text-primary"
                  />
                  {feature.name}
                </dt>
                <dd className="mt-1 flex flex-auto flex-col text-base leading-7 text-gray-600">
                  <p className="flex-auto">{feature.description}</p>
                  <p className="mt-6">
                    <a
                      href={feature.href}
                      className="text-sm font-semibold leading-6 text-primary"
                    >
                      Learn more <span aria-hidden="true">→</span>
                    </a>
                  </p>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}
